/* eslint-disable */
export function getAuthorization(params, method) {
  const crypto = require('crypto');
  const hmac = crypto.createHmac('sha1', 'RtjBo6FsOhCiuiIQIR21LJXq6u7kFPCz');

  const signTime = Date.now();

  hmac.update(signTime.toString());
  const signKey = hmac.digest('hex');

  const httpString = `${method}\n/panorama/pea.jpg\n${params}\nhost=vrapi.aibee.cn\n`;
  console.log(httpString)
  const hash = crypto.createHash('sha1');
  hash.update(httpString);
  const sha1edHttpString = hash.digest('hex');

  const stringToSign = `sha1\n${signTime}\n${sha1edHttpString}\n`;

  const sign = crypto.createHmac('sha1', signKey);

  sign.update(stringToSign);

  const signatrue = sign.digest('hex');

  return `LjJp7PdcIvBxdX2tS9wKSc47kkVjp64x/${signTime.toString()}/${signatrue}`;
}
